var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AProgress',_vm._b({attrs:{"id":"progress","percent":Number(_vm.value),"type":_vm.type,"width":_vm.size,"format":_vm.format}},'AProgress',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }